import React from "react";
import "./Home.css";
import Hero from "../Hero/Hero";
import OneClickSection from "../OneClickSection/OneClickSection";
import Services from "../Services/Services";
import Banner from "../Banner/Banner";
import Process from "../Process/Process";
import Strategies from "../Strategies/Strategies";
import WhyChooseUs from "../WhyChooseUs/WhyChooseUs";

const Home = () => {
  return (
    <main className="home-wrapper">
      <section className="home-section hero-section">
        <Hero />
      </section>

      <section className="home-section light-section">
        <OneClickSection />
      </section>

      <section className="home-section">
        <div className="section-intro">
          <h2>Digital Services That Drive Results</h2>
          <p>
            From stunning websites to targeted marketing campaigns — we deliver
            end-to-end digital solutions tailored to your business goals.
          </p>
        </div>
        <Services />
      </section>

      <section className="home-section dark-section">
        <Banner />
      </section>

      <section className="home-section">
        <div className="section-intro">
          <h2>How We Work With You</h2>
          <p>
            A transparent, step-by-step process from discovery to launch —
            with regular updates and zero surprises.
          </p>
        </div>
        <Process />
      </section>

      <section className="home-section light-section">
        <div className="section-intro">
          <h2>Growth Strategies That Deliver</h2>
          <p>
            Data-driven approaches combining SEO, content, and paid channels
            to bring qualified traffic and real conversions.
          </p>
        </div>
        <Strategies />
      </section>

      <section className="home-section">
        <div className="section-intro">
          <h2>Why Choose Setup Help Online</h2>
          <p>
            We're not just another agency — we're your long-term digital partner
            focused on measurable growth.
          </p>
        </div>
        <WhyChooseUs />
      </section>
    </main>
  );
};

export default Home;
